import { render, staticRenderFns } from "./ModalAddVideos.vue?vue&type=template&id=89713472&scoped=true&"
import script from "./ModalAddVideos.vue?vue&type=script&lang=js&"
export * from "./ModalAddVideos.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddVideos.vue?vue&type=style&index=0&id=89713472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89713472",
  null
  
)

export default component.exports